import { useEffect, useState } from 'react';
import { redirectToUrl, isValidUrl, isValidSmsParams } from '../utils/urlUtils';

const isAndroid = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /Android/i.test(userAgent);
};

const formatSMSLink = (link) => {
  return isAndroid() ? link.replace('&', '?') : link;
};

const redirectToSMS = (queryParams) => {
  const { r: link } = queryParams;
  if (!link) {
    throw new Error('No URL provided');
  }

  if (!isValidSmsParams(link)) {
    throw new Error('Invalid SMS parameters');
  }

  const formattedLink = formatSMSLink(link);
  if (isValidUrl(formattedLink)) redirectToUrl(formattedLink);
};

export const useSmsRedirect = (queryParams) => {
  const [error, setError] = useState(null);
  useEffect(() => {
    // Wait until we have actual query parameters
    if (!queryParams || Object.keys(queryParams).length === 0) {
      return;
    }
    try {
      redirectToSMS(queryParams);
    } catch (err) {
      setError(err);
    }
  }, [queryParams]);

  return { error };
}
